import { useState, useContext } from "react";
import { FiltersContext } from "@/contexts";
import { DeletionPreventionData } from "@/interfaces";

export const useDeletionPrevention = (filterId: string) => {
  const context = useContext(FiltersContext);
  const [showDeletionPreventionModal, setShowDeletionPreventionModal] =
    useState(false);
  const [deletionPreventionData, setDeletionPreventionData] =
    useState<DeletionPreventionData | null>(null);

  const checkDeletionPrevention = async (): Promise<boolean> => {
    if (!context) return true;
    try {
      const deletionResponse =
        await context.getDeletionPreventionStatus(filterId);

      if (deletionResponse?.status === "error" && deletionResponse?.blocked) {
        setDeletionPreventionData(deletionResponse);
        setShowDeletionPreventionModal(true);
        return false; // Deletion is blocked
      }

      return true; // Deletion can proceed
    } catch (e) {
      console.error("Error checking deletion dependencies:", e);
      return false; // Err on the side of caution
    }
  };

  const closeDeletionPreventionModal = () => {
    setShowDeletionPreventionModal(false);
    setDeletionPreventionData(null);
  };

  return {
    showDeletionPreventionModal,
    deletionPreventionData,
    checkDeletionPrevention,
    closeDeletionPreventionModal,
  };
};
